import "./PwVergessen.css";
import PropTypes from "prop-types";
import BisButton from "../components/bisButton/BisButton";
import BisTextfield from "../components/bisTextfield/BisTextfield";
import {useEffect, useRef, useState} from "react";

function PasswortVergessen({onZurueckClick}) {
    const [username, setUsername] = useState('');
    const [usernameError, setUsernameError] = useState('');
    const [text, setText] = useState(
        "Geben Sie Ihren Benutzernamen in das Textfeld ein. Sie erhalten eine E-Mail an die hinterlegte E-Mailadresse und können ein neues Passwort vergeben."
    );
    const [submitted, setSubmitted] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const zurueckButtonRef = useRef(null);


    const onResetClick = async () => {
        if (isLoading) {
            return;
        }

        const usernameIsValid = validateInput();

        if (!usernameIsValid) {
            return;
        }

        setIsLoading(true);

        try {
            const result = await sendResetRequest();
            console.log(result);

            setText(
                "Wenn der Account existiert und aktiv ist, erhalten Sie eine E-Mail an die hinterlegte E-Mailadresse. Sollten Sie keine E-Mail erhalten, wenden Sie sich bitte an "
            );
            setSubmitted(true);

            setTimeout(() => {
                zurueckButtonRef.current?.focus();
            }, 0);
        } finally {
            setIsLoading(false);
        }
    };

    const validateInput = () => {
        let valid = true

        if (!username) {
            setUsernameError("Bitte geben Sie Ihren Benutzernamen ein");
            valid = false;
        } else {
            setUsernameError("");
        }

        return valid;
    }

    const sendResetRequest = async () => {
        const response = await fetch(`${window.location.origin}/bis-login2/password-reset`, {
            method: 'POST',
            credentials: "include",
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({username}),
        });
        return response.status;
    }

    useEffect(() => {
        if (usernameError) {
            document.getElementById('field-username').focus();
        }
    }, [usernameError]);

    return (
        <div className="pwvergessen-container">
            <div className="pwvergessen-text" aria-live="polite">
                {text}
                {submitted && (
                    <a href="mailto:bis-bokat@lfu.rlp.de">bis-bokat@lfu.rlp.de</a>
                )}
            </div>
            {!submitted && (
                <>
                    <BisTextfield
                        id="field-username"
                        label="Benutzername"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        className="pw-reset-username"
                        error={usernameError}
                        aria-invalid={usernameError ? "true" : "false"}
                        aria-describedby={usernameError ? "field-username-error" : undefined}
                    />

                    <BisButton
                        id="btn-reset-password"
                        onClick={onResetClick}
                        aria-label="Passwort zurücksetzen"
                        aria-busy={isLoading}
                        text={isLoading ? "Passwort zurücksetzen..." : "Passwort zurücksetzen"}
                        className={`pwvergessen-reset ${isLoading ? "is-loading" : ""}`}
                        disabled={isLoading}
                    />
                </>
            )}
            <BisButton id="btn-zurueck-anmeldung"
                       onClick={onZurueckClick}
                       aria-label="Zurück zur Anmeldeseite"
                       text="Zurück zur Anmeldung"
                       className="pwvergessen-zurueck"
                       ref={zurueckButtonRef}/>

        </div>
    );
}

PasswortVergessen.propTypes = {
    onZurueckClick: PropTypes.func.isRequired,
};

export default PasswortVergessen;
